<template>
  <div :class="containerClassObject">
    <div v-if="!hideLabel" :id="`${id}-label`" class="wm-field-label">
      <label v-if="label" :for="id" :class="{required: required}" v-html="label"/>
    </div>
    <div class="wm-field-input">
      <input
        :id="id"
        :type="type"
        :name="name"
        :value="value"
        :class="{ error: $v.$error }"
        :placeholder="placeholder"
        :maxlength="maxlength"
        :readonly="readonly"
        :disabled="disabled"
        @input="onInput"
        @focus="onFocus"
        @blur="onBlur"
      >
      <tooltip v-if="tooltip" :title="tooltip.content" :position="tooltip.position || 'right'"/>
    </div>
    <validation-message-list
      v-if="!disabled || !readonly"
      :$v="$v"
      :property-path="name"
      :translation-name-space="validationMessageTranslationNameSpace"
    />
  </div>
</template>

<script>
import ValidationMessageList from '../ValidationMessageList'
import ValidationField from './ValidatedField'
import Tooltip from '../../Tooltip'

/* @flow */
export default {
  name: 'InputField',
  components: {
    ValidationMessageList,
    Tooltip
  },
  extends: ValidationField,
  props: {
    $v: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: 'text'
    },
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    value: {
      type: String | Number,
      default: ''
    },
    label: {
      type: String,
      required: false,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    maxlength: {
      type: Number,
      default: 524288
    },
    normalizationFilter: {
      type: Function,
      default: (v) => { return v }
    },
    customContainerClasses: {
      type: Array,
      required: false,
      default: () => ['small-12', 'wm-field', 'columns']
    },
    hideLabel: {
      type: Boolean,
      default: false
    },
    validationMessageTranslationNameSpace: {
      type: String,
      default: 'companyForm'
    },
    tooltip: {
      type: Object,
      required: false,
      default: null
    }
  },
  computed: {
    containerClassObject () {
      const containerClassObject = {}
      this.customContainerClasses.forEach(className => {
        containerClassObject[className] = true
      })

      return containerClassObject
    }
  },
  methods: {
    onInput (e) {
      const normalizedValue = this.normalizationFilter(e.target.value)
      this.$emit('input', e.target.value)
      if (normalizedValue !== e.target.value) {
        this.$emit('input', normalizedValue)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/fields/InputField.vue